module.exports = __webpack_public_path__ + "img/logo.3bff21a1.svg";